import Cookies from 'js-cookie';


// nome del cookie contenente baseuri e apikey di CalAmp
var keyBase = 'Crashboxx_2';
// separatore delle info salvate dentro il cookie
var dataSeparator = '§';

/**
 * restituisce nome del cookie con baseuri e apikey di CalAmp
 */
export function getAppCookieName() {
    var name = window.location.hostname + "_" + keyBase;
    return name;
}

/**
 * nome del cookie contenente info su filtri di ricerca
 */
export function getAppSearchDataCookieName() {
    var name = window.location.hostname + "_SearchFilters_" + keyBase;
    return name;
}

/**
 * nome del cookie contenente info su impaginazione
 */
export function getAppPaginationCookieName() {
    var name = window.location.hostname + "_Pagination_" + keyBase;
    return name;
}

/**
 * nome del cookie contenente info su auth di jasper
 */
export function getJasperCookieName() {
    var name = window.location.hostname + "_Jasper_" + keyBase;
    return name;
}

/**
 * nome del cookie contenente info su lingua corrente
 */
export function getLanguageCookieName() {
    var name = window.location.hostname + "_Language_" + keyBase;
    return name;
}

/**
 *  salva i filtri di ricerca
 */
export function savePagination(pagination){
    var today = new Date();
    var expiresValue = new Date(today);

    expiresValue.setMinutes(today.getMinutes() + 120);

    if(!pagination)
    {
        Cookies.remove(getAppPaginationCookieName());
        return;
    }

    Cookies.remove(getAppPaginationCookieName());
    Cookies.set(getAppPaginationCookieName(), JSON.stringify(pagination), {expires: expiresValue});
}

/**
 * cancella cookie di Crashboxx contenente l'impaginazione
*/
export function deletePagination(){
    Cookies.remove(getAppPaginationCookieName());
}

/**
 * restituisce impaginazione
*/
export function getPagination(){
    var data = Cookies.get(getAppPaginationCookieName());
    if(!data) return null;
    return JSON.parse(data);
}

/**
 *  salva i filtri di ricerca
 */
export function saveSeachFilters(sourcedata){
    var today = new Date();
    var expiresValue = new Date(today);

    expiresValue.setMinutes(today.getMinutes() + 120);

    if(!sourcedata)
    {
        Cookies.remove(getAppSearchDataCookieName());
        return;
    }

    var data = {
        icnId: sourcedata.icnId,
        vin: sourcedata.vin,
        deviceFilterValue: sourcedata.deviceFilterValue,
        dateFrom: sourcedata.dateFrom,
        dateTo: sourcedata.dateTo,
        selectedSeverityValues: sourcedata.selectedSeverityValues,
        selectedClassificationValue: sourcedata.selectedClassificationValue,
        selectedDeviceIdType: sourcedata.selectedDeviceIdType,
        includeSubAccount: sourcedata.includeSubAccount,
        selectedAccount: sourcedata.selectedAccount
    }

    Cookies.remove(getAppSearchDataCookieName());
    Cookies.set(getAppSearchDataCookieName(), JSON.stringify(data), {expires: expiresValue});
}

/**
 * cancella cookie di Crashboxx contenente i filtri di ricerca
*/
export function deleteSeachFilters(){
    Cookies.remove(getAppSearchDataCookieName());
}

/**
 * restituisce i filtri di ricerca
*/
export function getSeachFilters(){
    var data = Cookies.get(getAppSearchDataCookieName());
    if(!data) return null;
    return JSON.parse (data);
}

/**
 *  salva id della lista di settings.ApplicationKeyList + ulteriori info su baseuri e AppKey
 */
export function saveApplication(selectedApp){
    var today = new Date();
    var expiresValue = new Date(today);

    /*
        faccio scadere dopo il cookie di calAmp
        se CalAmp dà unauthorized allora verrà chiamato
        il metodo di clear cookie
    */
    expiresValue.setMinutes(today.getMinutes() + 120);

    var appData = getAppCookie();
    var username = null;
    var pwd = null;

    if(appData)
    {
        username = appData.username;
        pwd = appData.pwd;
    }

    var data = btoa(username) + dataSeparator + btoa(pwd) + dataSeparator + btoa(selectedApp.baseUri)
        + dataSeparator + btoa(selectedApp.key)
        + dataSeparator + btoa(selectedApp.jasperConnect);

    Cookies.remove(getAppCookieName());
    Cookies.set(getAppCookieName(), data, {expires: expiresValue});
}

/**
 *  salva id della lista di settings.ApplicationKeyList + ulteriori info su baseuri e AppKey
 */
export function saveAppCookie(username, pwd, selectedApp){
    var today = new Date();
    var expiresValue = new Date(today);

    /*
        faccio scadere dopo il cookie di calAmp
        se CalAmp dà unauthorized allora verrà chiamato
        il metodo di clear cookie
    */
    expiresValue.setMinutes(today.getMinutes() + 120);

    var data = btoa(username) + dataSeparator + btoa(pwd) + dataSeparator + btoa(selectedApp.baseUri)
        + dataSeparator + btoa(selectedApp.key)
        + dataSeparator + btoa(selectedApp.jasperConnect);

    Cookies.remove(getAppCookieName());
    Cookies.set(getAppCookieName(), data, {expires: expiresValue});
}
/**
 * cancella cookie di Crashboxx contenente baseuri e apikey di CalAmp
*/
export function deleteAppCookie(){
    Cookies.remove(getAppCookieName());
}

/**
 * restituisce info su applicazione selezionata
 * id - baseUri - appKey
*/
export function getAppCookie(){
    var cookiedata = Cookies.get(getAppCookieName());
    if (!cookiedata) {
        return null;
    }

    var appData = { username: '', pwd: '', appId: '' };

    var arr = cookiedata.split(dataSeparator);
    if (arr && arr.length > 0) {
        appData.username = atob(arr[0]);
        appData.pwd = atob(arr[1]);
        appData.baseUri = atob(arr[2]);
        appData.key = atob(arr[3]);
        appData.jasperConnect = atob(arr[4]);
    }

    return appData;
}


/**
 *  salva info di auth di jasper
 */
export function saveJasperSessionId(sessionId){
    var today = new Date();
    var expiresValue = new Date(today);

    expiresValue.setMinutes(today.getMinutes() + 120);

    if(!sessionId)
    {
        Cookies.remove(getJasperCookieName());
        return;
    }

    Cookies.remove(getJasperCookieName());
    Cookies.set(getJasperCookieName(), JSON.stringify(sessionId), {expires: expiresValue});
}

/**
 * restituisce auth di jasper
*/
export function getJasperSessionId(){
    var data = Cookies.get(getJasperCookieName());
    if(!data) return null;
    return JSON.parse(data);
}

/**
 * cancella cookie di jasper
*/
export function deleteJasperSessionCookie(){
    Cookies.remove(getJasperCookieName());
}




/**
 *  salva info di auth di jasper
 */
export function saveLanguageCode(langCode){
    var today = new Date();
    var expiresValue = new Date(today);

    expiresValue.setMinutes(today.getMinutes() + 120);

    if(!langCode)
    {
        Cookies.remove(getLanguageCookieName());
        return;
    }

    Cookies.remove(getLanguageCookieName());
    Cookies.set(getLanguageCookieName(), JSON.stringify(langCode), {expires: expiresValue});
}


/**
 * restituisce auth di Language
*/
export function getLanguageCode(){
    var data = Cookies.get(getLanguageCookieName());
    if(!data) return null;
    return JSON.parse(data);
}

/**
 * cancella cookie di Language
*/
export function deleteLanguageCodeCookie(){
    Cookies.remove(getLanguageCookieName());
}


// WEBPACK FOOTER //
// ./src/services/cookies/cookieServices.js